import axios from "axios";

import { logError } from "@Helpers/logger.js";
import { HttpRouter } from "@Modules/shared/interfaces/HttpRouter";

export type EmailVerificationApi = {
  resendVerificationEmail: () => Promise<boolean>
  setRouter: (router: HttpRouter<"post">) => EmailVerificationApi
}

type ResendResponse = { resent: boolean };

/**
 * Talks to the email verification endpoints for the signed-in user.
 */
export default function EmailVerificationApi(): EmailVerificationApi {
  let router: HttpRouter<"post"> = axios;

  const that: EmailVerificationApi = {
    /**
     * Asks the server to send a fresh verification link, answering whether one
     * went out. The server answers false when the address is already verified.
     */
    resendVerificationEmail: async function (): Promise<boolean> {
      try {
        const response = await router.post<ResendResponse>("/app/api/email/resend");

        return response.data.resent === true;
      } catch (error) {
        logError("Failed to resend the verification email");

        return false;
      }
    },

    /**
     * Allows you to swap out the router for a fake one when writing tests
     */
    setRouter(newRouter: HttpRouter<"post">) {
      router = newRouter;

      return that;
    },
  };

  return that;
}
